import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Notification, useToaster } from "rsuite";
import { Tag, IconButton } from "rsuite";
import { Translation } from "react-i18next";
import { PartnerService } from "_services";
import i18n from "i18n";
import Table from "rc-table";
import { HiUserGroup, HiOutlineUserGroup } from "react-icons/hi2";
import { HiDocumentReport, HiOutlineDocumentReport } from "react-icons/hi";
import { IoGameController, IoGameControllerOutline } from "react-icons/io5";
import ChildFinansReportDetailTable from "./ChildFinansReportDetailTable";

const columns = [
  {
    title: "Category",
    dataIndex: "Category", //["RelUser", "UserID"],
    className: "text-xs",
    key: "Category",
    width: 160,
  },

  {
    title: "In - Out",
    dataIndex: "InOut",
    className: "text-xs table-cell sm:hidden",
    key: "InOut",
    width: 200,
    render: (value) => (
      <div className={`p-2 rounded-md text-[10px]`}>
        <div>
          <span>
            {`In : ${value.in.toLocaleString("tr-TR", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}`}
          </span>
        </div>

        <div>
          <span>
            {`Out : ${value.out.toLocaleString("tr-TR", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}`}
          </span>
        </div>
      </div>
    ),
  },

  {
    title: "In",
    dataIndex: "in",
    className: "text-xs  hidden sm:table-cell",
    key: "In",
    width: 80,
    render: (value) => (
      <div className={`p-2 rounded-md `}>
        <span>
          {value.toLocaleString("tr-TR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
    ),
  },
  {
    title: "Out",
    dataIndex: "out",
    className: "text-xs hidden sm:table-cell",
    key: "Out",
    width: 80,
    render: (value) => (
      <div className={`p-2 rounded-md `}>
        <span>
          {value.toLocaleString("tr-TR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
    ),
  },
  {
    title: "GGR",
    dataIndex: "ggr",
    className: "text-xs text-right",
    key: "GGR",
    width: 50,
    render: (value) => (
      <div
        className={`p-2 rounded-md  text-[10px] sm:text-[12px] md:text-xs  ${
          value > 0
            ? "bg-green-700"
            : value == "0"
            ? "bg-transparent"
            : "bg-red-700"
        }`}
      >
        <span>
          {value.toLocaleString("tr-TR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
    ),
  },
];

const ChildFinansReportTable = ({ rowData, childs }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null);

  const toaster = useToaster();
  const message = (msg, type) => {
    return <Notification type={type} header={msg} closable></Notification>;
  };

  const onExpand = (expanded, record) => {
    // eslint-disable-next-line no-console
    //console.log("onExpand", expanded, record);
  };
  function CustomExpandIcon(props) {
    // debugger;

    return (
      <div
        className={`btn btn-primary text-white ${
          props.expanded ? "" : "btn-outline"
        } btn-sm btn-square`}
        onClick={(e) => {
          props.onExpand(props.record, e);
        }}
        // eslint-disable-next-line react/no-danger
      >
        {props.expanded ? (
          props.record?.Reports?.length > 0 ? (
            <HiOutlineDocumentReport />
          ) : props.record.hasOwnProperty("Detail") ? (
            <IoGameControllerOutline />
          ) : (
            <HiOutlineUserGroup />
          )
        ) : props.record?.Reports?.length > 0 ? (
          <HiDocumentReport />
        ) : props.record.hasOwnProperty("Detail") ? (
          <IoGameController />
        ) : (
          <HiUserGroup />
        )}
      </div>
    );
  }

  return childs ? (
    <div className="py-1 bg-secondary-600 rounded-sm border border-secondary-400/20">
      {/*
        <div className="pb-2 px-2 border-b border-secondary-400/30">
        <label className="bold">{`${rowData.User.UserName} - (${rowData.RelUserType.Value})`}</label>
      </div>
      */}

      <Table
        className="table table-zebra "
        columns={columns}
        rowClassName={(record, i) =>
          `${record.Detail.length > 0 ? "" : "RemoveSubRow"} row-${i}`
        }
        expandable={{
          // expandRowByClick: true,
          expandedRowRender: (record) => {
            if (record.Detail.length > 0)
              return (
                <div className="py-1 bg-secondary-800 rounded-sm m-0">
                  <ChildFinansReportDetailTable
                    childs={record.Detail}
                    rowData={record}
                  />
                </div>
              );
            else {
              return undefined;
            }
          },
          onExpand,
          expandIcon: CustomExpandIcon,
        }}
        data={
          childs
            ? [
                ...childs.map((item, key) => ({
                  ...item,
                  key: item.Category + key,
                  InOut: item,
                })),
              ]
            : []
        }
      />
    </div>
  ) : (
    <></>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChildFinansReportTable);
